import React from "react";
import "./navbarTitle.sass";

interface INavbarTitleProps {
  title: string;
}

const NavbarTitle: React.FC<INavbarTitleProps> = ({title}) => {
  return (
    <div className="navbar-title">
      <span>{title}</span>
      <hr />
    </div>
  );
};

export default NavbarTitle;
